let patientsCache = null;
let lastFetched = 0;


export const getPatientsCache = () => patientsCache;

export const setPatientsCache = (data) => {
  patientsCache = data;
  lastFetched = Date.now();
};

export const updatePatientInCache = (patientId, updater) => {
  if (!patientsCache || !patientId || typeof updater !== "function") {
    return patientsCache;
  }

  const updateList = (list = []) =>
    list.map((patient) =>
      patient?._id === patientId ? updater(patient) : patient
    );

  patientsCache = {
    recent: updateList(patientsCache.recent || []),
    all: updateList(patientsCache.all || []),
  };
  lastFetched = Date.now();

  return patientsCache;
};

export const isCacheValid = (maxAge = 30000) => {
  return Date.now() - lastFetched < maxAge;
};

export const clearPatientsCache = () => {
  patientsCache = null;
  lastFetched = 0;
};
